import _ = require("underscore");

export class ProjectStorage{

    private fakeStorage?: {[name:string]:any };

    constructor(private projectId:string){
    }

    set(key: string, value: any){
        const map = this.getMap();
        map[key] = value;
        this.update(map);
    }
    get(key: string){
        return this.getMap()[key];
    }

    keys(){
        return _.keys(this.getMap());
    }

    unset(key: string){
        const map = this.getMap();
        delete map[key];
        this.update(map);
    }

    unsetAll(){
        this.update({});
    }

    getMap(){
        if(typeof(Storage)){
            return JSON.parse(localStorage.getItem(this.localStorageId()) || "{}");
        } else {
            // Fallback when localStorage is not supported
            return this.fakeStorage;
        }
    }
    update(map:{[name:string]:any }){
        if(typeof(Storage)){
            localStorage.setItem(this.localStorageId(), JSON.stringify(map));
        } else {
            // Fallback when localStorage is not supported
            this.fakeStorage = map;
        }
    }
    private localStorageId() {
        return `se2-storage-project-${this.projectId}`;
    }
}